import { UtilityService } from '@eforall/common';
import { GridSetup } from '@eforall/dashboard';
import { StaffData } from '@interfaces';
import { getActions } from './get-actions';
import { getColumns } from './get-columns';


export function getSetup(util: UtilityService): GridSetup<StaffData & { updatedUTC: number }> {

	return {
		rowName: { singular: 'Staff', plural: 'Staff' },
		getRowKey: row => '' + row.staffId,
		stateKey: 'staff-grid',
		actions: getActions(),
		buttons: [],
		columns: getColumns(util),
		renderRowClasses: row => row.status == 'Active' ? [] : ['grid-cell-strikethrough', 'grid-cell-gray-text'],
	}
}
